import "./Modal.scss";

function Modal({ isModalOpen, onClose, children }) {
  if (!isModalOpen) return null; // only render when open

  return (
    <div className="pay-modal-container" /*onClick={onClose}*/>
      <div className="pay-modal-content" onClick={(e) => e.stopPropagation()}>
        {/*
        <button className="am-modal-close" onClick={onClose}>
          ×
        </button>*/}
        {children}
      </div>
    </div>
  );
}

export default Modal;
